import React, { useState, useRef } from "react";
import { TooltipBlock } from "./styled";
import iIcon from "./../../../resources/images/icons/i.svg";
import closeIcon from "./../../../resources/images/icons/close_icon.svg";
import { Text } from "../../../styled";
import { blackColor } from "../../../constants/colors";
import { useOnOutsideClick } from "../../../hooks/useOutsideClick";

const Tooltip = (props) => {
  const { opacity, message, width, translateX } = props;

  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [leftCoord, setLeftCoord] = useState(0);

  const { innerBorderRef } = useOnOutsideClick(() => setTooltipVisible(false));
  const iconRef = useRef(null);

  const handleIconClick = (e) => {
    setTooltipVisible(!isTooltipVisible);
    let xCoord = -iconRef.current.getBoundingClientRect().x + 20;
    setLeftCoord(xCoord);
  };

  const handleCloseClick = () => {
    setTooltipVisible(false);
  };

  return (
    <>
      <TooltipBlock ref={innerBorderRef}>
        <TooltipBlock.Icon
          opacity={opacity}
          onClick={(e) => handleIconClick(e)}
          ref={iconRef}
        >
          <img src={iIcon} alt="i" />
        </TooltipBlock.Icon>
        {isTooltipVisible ? (
          <TooltipBlock.Message
            style={{ width: `${width - 40}px` }}
            left={leftCoord}
            translateX={translateX}
            triangleCoord={leftCoord}
          >
            <Text.Eight
              style={{
                color: blackColor,
                fontWeight: 400,
                fontStyle: "italic",
                letterSpacing: 0,
                textTransform: "none",
              }}
            >
              {message}
            </Text.Eight>
            <TooltipBlock.Close onClick={handleCloseClick}>
              <img src={closeIcon} alt="close" />
            </TooltipBlock.Close>
          </TooltipBlock.Message>
        ) : null}
      </TooltipBlock>
    </>
  );
};

export default Tooltip;
